import React, { useEffect, useState } from "react";
import { getData, postData } from '../middleware/apiMiddleware';
import s from './RelatedItems.module.css';
import { useNavigate } from "react-router-dom";
import { RedButton } from './MyButton'; // Assuming BlueButton/GreenButton were unused

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function RelatedItems(prop) {	
	const navigate = useNavigate();
	
	const { itemId } = prop; // Destructure for cleaner access
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [data, setData] = useState([]);
	// State for the textarea, allowing multiple IDs
	const [newItemIdsToAdd, setNewItemIdsToAdd] = useState("");
	
	/**
	 * Processes the list of IDs from the textarea, sends requests to add them,
	 * and then refreshes the data.
	 */
	const handleBatchAddItems = async () => {
		// 1. Split the string by newline, trim whitespace from each ID, and filter out any empty lines.
		const idsToAdd = newItemIdsToAdd
			.split('\n')
			.map(id => id.trim())
			.filter(id => id !== "");

		if (idsToAdd.length === 0) {
			return; // Do nothing if the input is empty
		}

		try {
			// 2. Create an array of promises, one for each "add" API call.
			const addPromises = idsToAdd.map(relatedItemId => {
				const payload = { itemId, relatedItemId };
				return postData("item/addRelatedItem", payload, navigate);
			});
	
			// 3. Use Promise.all to run all API calls concurrently for better performance.
			await Promise.all(addPromises);
	
			// 4. After all items are added, clear the input and refresh the list once.
			setNewItemIdsToAdd("");
			fetchData();

		} catch (error) {
			console.error("Failed to add one or more related items:", error);
			// Optionally, show an error message to the user
			alert("An error occurred while adding items. Please check the console and try again.");
			// Still refresh data to see which ones (if any) succeeded
			fetchData();
		}
	}
	
	const removeRelatedItem = async (relatedItemId) => {
		// Optimistic UI update: remove item from the list immediately for a faster user experience.
		const tmpData = data.filter(d => d.id !== relatedItemId);
		setData(tmpData); // Use the new array without spread for clarity

		// Then, send the request to the server in the background.
		const payload = { itemId, relatedItemId };
		try {
			await postData("item/removeRelatedItem", payload, navigate);
		} catch (error) {
			console.error("Failed to remove item. Re-fetching to sync state.", error);
			// If the API call fails, re-fetch the data to revert the optimistic update.
			fetchData();
		}
	}
	
	const fetchData = async () => {
		getData(`item/getRelatedItemByItemId?itemId=${itemId}`, navigate)
			.then(res => {
				setData(res.data);			
				setFetchCompleted(true);
			})
			.catch(err => {
				console.error("Failed to fetch related items:", err);
				setFetchCompleted(true); // Stop loading even if there's an error
			});
	}

	useEffect(() => {
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []); // itemId is stable from props, so we only fetch once on mount.
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />);
	}
	
	return (<div>
		{/* Section for adding new items */}
		<div style={{display:"flex", alignItems:"center", borderBottom:"1px solid black", paddingBottom: "10px"}}>
			<div style={{fontSize:"1.5rem"}}>
				Add Related Items
			</div>
			<div className={s.itemHolder}>
				{/* Changed to a textarea for multi-line input */}
				<textarea 
					value={newItemIdsToAdd} 
					className={s.idTextarea}
					placeholder="Paste one ID per line..."
					onChange={(e)=>{
						setNewItemIdsToAdd(e.target.value);
					}} 
				/>
				<div 
					className={(newItemIdsToAdd.trim()) ? s.btnActive : s.btnInactive} 
					onClick={handleBatchAddItems}
				>
					Add
				</div>
			</div>
		</div>
	
		{/* Header for the items list */}
		<div className={s.rowHolder} style={{fontWeight: "bold", marginTop: "10px"}}>
			<div>Item ID</div>
			<div style={{flexBasis:"500px"}}>Name</div>
		</div>
	
		{/* List of existing related items */}
		{
			data.map((d, indexD)=>(
				<div key={d.id} className={s.rowHolder} style={(indexD % 2 === 0) ? {background:"#dae6e8"} :{}}>
					<div>{d.id}</div>
					<div style={{flexBasis:"500px"}}>{d.name}</div>
					<div style={{margin:"0 0 0 auto"}}>
						<RedButton isEnabled={true} clickedAction={()=>removeRelatedItem(d.id)} bText={"Remove"} />
					</div>
				</div>
			))
		}
	</div>);
}